module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_11.3613f383.jpg";